const BASE = '/young-connect';

export const youngConnectPaths = {
  home: BASE,
  hetMeisjeHuis: `${BASE}/het-meisje-huis`,
  help: `${BASE}/hulp`,
} as const;
